import { Dispatch, GetState } from "common/types";

import { getClient } from "services";
import errorHandler from "services/parentsService/errorHandler";

import { ChildConnectionSource } from "seneca-common/features/parents/features/student-parents/service/hooks/types";

import {
  deleteParent,
  fetchStudentParentsActionFactory,
  receiveParent,
  receiveParents,
  studentParentsNeedFetching,
  updateStudentParentsActionFactory
} from "../state";

const getParentsServiceClient = () => getClient("parentsService");

const makeFetchStudentParents = (getClient: any) => {
  return fetchStudentParentsActionFactory({
    requestFunction: () => getClient().fetchChild(),
    storeAction: receiveParents,
    errorHandler
  });
};

const makeFetchStudentParentsIfNotFetched = (getClient: any) => {
  const fetchStudentParents = makeFetchStudentParents(getClient);
  return () => async (dispatch: Dispatch, getState: GetState) => {
    const state = getState();

    if (studentParentsNeedFetching(state)) {
      dispatch(fetchStudentParents());
    }
  };
};

const makeAddStudentToParentAction = (getClient: any) => {
  return updateStudentParentsActionFactory({
    requestFunction: code => getClient().addMyParent(code),
    storeAction: receiveParent,
    errorHandler
  });
};

const makeRemoveStudentFromParentAction = (getClient: any) => {
  return updateStudentParentsActionFactory({
    requestFunction: parentUserId => getClient().removeMyParent(parentUserId),
    errorHandler
  });
};

const makeAddStudentToParentByEmailAction = (getClient: any) => {
  return updateStudentParentsActionFactory({
    requestFunction: ({ email, source }) =>
      getClient("parentsService").addMyParentByEmail(email, source),
    errorHandler
  });
};

//fetch my parents
export const fetchStudentParentsIfNotFetched =
  makeFetchStudentParentsIfNotFetched(getParentsServiceClient);

export const fetchStudentParents = makeFetchStudentParents(
  getParentsServiceClient
);

//add me to parent
export const addParent = (parentCode: string) =>
  makeAddStudentToParentAction(getParentsServiceClient)(parentCode);

//add me to parent by email
export const addParentByEmail = (
  email: string,
  source: ChildConnectionSource
) =>
  makeAddStudentToParentByEmailAction(getParentsServiceClient)({
    email,
    source
  });

//remove me from parent
export const removeParent = (parentId: string) => {
  const removeStudentFromParentAction = makeRemoveStudentFromParentAction(
    getParentsServiceClient
  );
  return async (dispatch: Dispatch) => {
    const output = await dispatch(removeStudentFromParentAction(parentId));

    if (!(output instanceof Error)) {
      dispatch(deleteParent(parentId));
    }
  };
};
